import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();
const THEME_KEY = 'appTheme';

export const ThemeProvider = ({ children }) => {
  // Initialize theme from localStorage or default to 'white'
  const [theme, setTheme] = useState(() => {
    const savedTheme = localStorage.getItem(THEME_KEY);
    return savedTheme || 'white';
  });

  // Save theme to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem(THEME_KEY, theme);
  }, [theme]);

  // Carbon primenjuje temu na <Theme> omotač unutar #root-a, pa <html>/<body>
  // zadržavaju podrazumevanu (svetlu) pozadinu iz :root teme. Na telefonu se
  // ta bela površina vidi pri "overscroll"-u. Zato aktivnu temu ogledamo i na
  // <html> elementu; globalna CSS pravila (src/index.css) na osnovu toga boje
  // pozadinu dokumenta i isključuju overscroll efekat.
  useEffect(() => {
    document.documentElement.setAttribute('data-app-theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prevTheme => prevTheme === 'white' ? 'g100' : 'white');
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
